module.exports = __webpack_public_path__ + "ck.7ab1552eaaca620c2ba1.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ck.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ck.svg
// module chunks = styles